// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpanError_wrapper__9wwgK {
  color: red;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SpanError/SpanError.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,eAAe;AACjB","sourcesContent":[".wrapper {\r\n  color: red;\r\n  font-size: 12px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `SpanError_wrapper__9wwgK`
};
export default ___CSS_LOADER_EXPORT___;
